module.exports = __webpack_public_path__ + "media/images/roberge_testimonial_2x-1ade9f9bdc5f442b47f0662f7e29acc5.png";